import { CountryCodes } from '../constants';
import fetchEcomm from '../util/fetchEcomm';
import { fetchApi, buildFetchContext } from '../util/fetch-api';
import fetchCountryCode from './geolocation';
import { getAllFlagsState } from './feature-flags';


/**
 * Attempts to fetch user.
 * Sends a request to server with authentication to validate against.
 * @param {Object} [options] Options to pass to fetch()
 * @returns {Promise} Always resolves. Will either resolve with
 * js object if user session, or null if no user session.
 */
export async function fetchUser(options = {}) {
  let fetchImpl = fetchApi;
  if (options.context) {
    const { fetchWithToken } = buildFetchContext(options.context);
    fetchImpl = fetchWithToken;
  }

  try {
    const json = await fetchImpl('/user/v1/profile', options);
    return { ...json, is_admin: (json.roles && json.roles.length > 0) };
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to fetch referral info.
 * /storefront/api uses a cookie to check for referral codes.
 * However, if a referral_code kid is passed through, it will
 * use this to set a new cookie.
 * Passing through the kid allows us to set referrals from any gf-dotcom page
 * using query params.
 */
export const fetchReferralInfo = async (kid) => {
  let url = `/storefront/api/referral`;

  /** If a kid param is specified pass it down to the ecom API to
   * replace any referral code that is stored on the session.
   */
  if (kid) {
    const params = new URLSearchParams({
      referral_code: kid,
    });

    url += `?${String(params)}`;
  }

  try {
    // Referral information is public - do not require authentication
    return await fetchEcomm(url);
  } catch (e) {
    return {};
  }
};

/**
 * Fetch a list of products
 *  This has now been modified to get products for different countries
 * @param {Object} context The context object from getInitialProps
 * @param {Object} [options]
 * @param {String} options.forceCountryCode Don't fetch country code,
 * just force one
 * @returns {Promise<Object>} Returns the promise to get you the GF products
 */
export const fetchProducts = async (context, options = { forceCountryCode: null }) => {
  try {
    const { fetchWithToken } = buildFetchContext(context);
    const flagStates = await getAllFlagsState();
    const { 'space-monkeys': ENABLED_COUNTRIES } = flagStates;
    // Get the requested country code for this session from cloudfront headers
    // (client or server-side)
    let countryCode = options.forceCountryCode ?
      options.forceCountryCode : await fetchCountryCode(context);
    if (!ENABLED_COUNTRIES?.includes(countryCode)) {
      countryCode = CountryCodes.US;
    }
    const json = await fetchWithToken(
      `/ecom/v1/shopify_products?country=${countryCode}`, { includeAuth: false });
    return json.products;
  } catch (e) {
    console.log(e)
    return {};
  }
};
